<template lang="pug">
  .section-layout
    .nav-back-btn(@click="goBack")
    .content-layout-list
      h2.title-filter 数据统计
      .section-filter
        .field-group.is-horizontal
          .field
            label.label 起止时间
            .field.is-horizontal
              date-picker.w-160(type="single", placeholder="选择开始时间", v-model="filter_data.start_time")
              span.margin 至
              date-picker.w-160(type="single", placeholder="选择结束时间", v-model="filter_data.end_time")
          .field
            a.button.primary(@click="search") 搜索
          .field
            a.button(@click="reset") 重置
          .field
            a.button(@click="exportTable") 导出
      .revenue.top-total
        div
          h2.m-b-20 页面访问统计
            el-popover.tips-text(placement="top-start", width="300", trigger="hover")
              .tips_page
                p 页面访问人数：统计访问活动页面的去重用户数；
                p 页面访问次数：统计访问活动页面的总次数；
                p 页面跳转人数：统计在活动页面跳转到二级页面的去重用户数；
                p 页面跳转次数：统计在活动页面跳转到二级页面的总次数。
              .el-icon-question(slot="reference")
          div.income
            div.statistics.no-border
              div.title 页面访问人数
              div.price {{statistic_data.visitor_count}}
            div.statistics
              div.title 页面访问次数
              div.price {{statistic_data.visit_count}}
            div.statistics
              div.title 页面跳转人数
              div.price {{statistic_data.transition_customer_count}}
            div.statistics
              div.title 页面跳转次数
              div.price {{statistic_data.transition_count}}
      .revenue.top-total
        div
          h2.m-b-20 订单转化统计
            el-popover.tips-text(placement="top-start", width="300", trigger="hover")
              .tips_order
                p 订单转化统计，只包含活动页面关联的商品/服务/养护卡的订单。
                p 下单人数：统计活动关联商品/服务/养护卡的下单用户数（去重）；
                p 订单数：统计活动关联商品/服务/养护卡的下单笔数；
                p 活动关联商品总金额：统计活动关联商品/服务/养护卡的商品总金额。
              .el-icon-question(slot="reference")
          div.income
            div.statistics.no-border
              div.title 下单人数
              div.price {{statistic_data.have_order === 0 ? '暂无' : statistic_data.order_customer_count}}
            div.statistics
              div.title 订单数
              div.price {{statistic_data.have_order === 0 ? '暂无' : statistic_data.order_count}}
            div.statistics
              div.title 活动关联商品总金额
              div.price {{statistic_data.have_order === 0 ? '暂无' : '￥' + (statistic_data.order_amount / 100).toFixed(2)}}
      .revenue.top-total
        div
          .head-content
            h2.m-b-20 好友助力统计
              el-popover.tips-text(placement="top-start", width="300", trigger="hover")
                .tips_page
                  p 发起助力人数：统计发起助力活动的总人数；
                  p 参与助力人数：统计参与助力活动的总人数；
                  p 成功助力数量：统计助力活动成功的总数量；
                  p 拉新数量：统计助力活动产生的新注册用户数量；
                .el-icon-question(slot="reference")
            a.operation-link(@click="goHelp" v-if="statistic_data.have_help === 1")  查看助力详情
          div.income
            div.statistics.no-border
              div.title 发起助力人数
              div.price {{statistic_data.have_help === 0 ? '暂无' : statistic_data.help_launch_count}}
            div.statistics
              div.title 参与助力人数
              div.price {{statistic_data.have_help === 0 ? '暂无' : statistic_data.help_join_count}}
            div.statistics
              div.title 成功助力数量
              div.price {{statistic_data.have_help === 0 ? '暂无' : statistic_data.help_success_count}}
            div.statistics
              div.title 拉新数量
              div.price {{statistic_data.have_help === 0 ? '暂无' : statistic_data.help_new_user_count}}
      empty-page.list-height(v-if="!order_statistic_data.length", :tip="'暂无订单统计数据'")
      .content-wrapper.revenue(v-if="order_statistic_data.length")
        div.order-statistics.p-t-20.inspect-store
          div
            ul.order-income
              li 订单号
              li 客户信息
              li 关联商品实收总额
              li 退款金额
              li 订单场景
              li 下单门店
              li 下单时间
              li 操作
          div(v-for="(item, index) in order_statistic_data")
            ul.order-income-content
              li {{item.order_no}}
              li {{item.nick_name}}
              li ￥{{(item.final_amount / 100).toFixed(2)}}
              li {{item.refund_price===''?'/':accDiv(item.refund_price,100)}}
              li {{getOrderType(item.order_type)}}
              li {{item.store_name}}
              li.date {{item.paid_at | date("yyyy-MM-dd HH:mm:ss", "cn")}}
              li
                a.operation-link(@click="goOrderDetail(item.order_id)",)  查看详情
          .tfoot(v-if="order_statistic_data.length")
            pagination(:pagination-data="pagination_data", @input="paging")

</template>

<script type="text/ecmascript-6">
import DatePicker from '@/components/generics/form/DatePicker'
import Pagination from '@/components/generics/Pagination'
import EmptyPage from '@/components/generics/EmptyPage'
import Api from '@/mixins/modules/Content'
import { root } from '@/plugins/Fetch'
import MathFun from '@/mixins/utilities/math'
import ExportApi from '@/mixins/modules/export'
export default {
  name: 'ContentStatistic',
  mixins: [Api, ExportApi, MathFun],
  components: {
    DatePicker,
    Pagination,
    EmptyPage,
  },
  data () {
    return {
      root,
      is_true: true, // 开始是否大于结束
      filter_data: {
        start_time: '',
        end_time: '',
      },
      query_data: {},
      pagination_data: {
        current_page: 1,
        per_page: 20,
        last_page: 2,
        total: 0,
      },
      statistic_data: {},
      order_statistic_data: [],
    }
  },
  watch: {
    'filter_data.start_time' (newVal, oldVal) {
      let start = 0
      let end = 0
      if (newVal === '') {
        newVal = 0
      } else {
        start = this.filter_data.start_time.replace(/-/g, '') - 0
        this.filter_data.end_time === '' ? end = 0 : end = this.filter_data.end_time.replace(/-/g, '') - 0
      }
      (start - end > 0 && end !== 0) ? this.is_true = false : this.is_true = true
    },
    'filter_data.end_time' (newVal, oldVal) {
      let start = 0
      let end = 0
      if (newVal === '') {
        newVal = 0
      } else {
        this.filter_data.start_time === '' ? start = 0 : start = this.filter_data.start_time.replace(/-/g, '') - 0
        end = this.filter_data.end_time.replace(/-/g, '') - 0
      }
      (start - end > 0 && start !== 0) ? this.is_true = false : this.is_true = true
    },
  },
  methods: {
    // 查看助力详情
    goHelp () {
      let search = {
        start_time: this.query_data.start_time,
        end_time: this.query_data.end_time,
      }
      localStorage.setItem('help-search', JSON.stringify(search))
      this.$router.push({
        name: 'helpStatistic',
        query: {
          help_id: this.statistic_data.help_id,
          activity_id: this.activity_id,
        },
      })
    },
    // 搜索
    search () {
      if (!this.is_true && this.filter_data.end_time !== '') {
        this.$store.dispatch('showMessage', {
          autoClose: true, // 控制弹框自动消失
          type: 'failure',
          title: '开始时间不能大于结束时间',
          resolve: () => this.$emit('failure'),
        })
        return false
      }
      this.pagination_data.current_page = 1
      for (let key in this.filter_data) {
        if (this.query_data.hasOwnProperty(key)) {
          this.query_data[key] = this.filter_data[key]
        }
      }
      this.getStatistic()
      this.getOrderStatistic()
    },
    getOrderType (type) {
      let arr = ['', '小程序直接下单', '智能保养', '拼团', '秒杀', '', '门店开单码', '快捷开单', '车检意向单', '其他', '线下录单']
      return arr[type]
    },
    // 重置
    reset () {
      this.filter_data = {
        start_time: '',
        end_time: '',
      }
      this.pagination_data.current_page = 1
      this.query_data = JSON.parse(JSON.stringify(this.filter_data))
      this.getStatistic()
      this.getOrderStatistic()
    },
    // 导出
    exportTable () {
      let params = `activity_id=${this.activity_id}&`
      let startTime = this.query_data.start_time ? new Date(this.query_data.start_time + ' 00:00:00').getTime() / 1000 : ''
      let endTime = this.query_data.end_time ? new Date(this.query_data.end_time + ' 23:59:59').getTime() / 1000 : ''
      params += `start_time=${startTime}&`
      params += `end_time=${endTime}&`

      // window.open(`${this.root}/activity/activity_order_export?${params}`)
      this.exportActivityOrder(params)
    },
    // 查看详情
    goOrderDetail (id) {
      this.$router.push({
        name: 'orderDetail',
        params: {
          id,
        },
      })
    },
    // 返回
    goBack () {
      this.$router.push({
        name: 'contentList',
        query: {
          save: 1,
        },
      })
    },
    // 分页
    paging (state) {
      this.pagination_data = state
      this.getOrderStatistic()
    },
    // 获取数据统计
    async getStatistic () {
      try {
        const { response, result } = await this.GetactivityStatisticApi(
          {
            activity_id: this.activity_id,
            start_time: this.query_data.start_time ? new Date(this.query_data.start_time + ' 00:00:00').getTime() / 1000 : '',
            end_time: this.query_data.end_time ? new Date(this.query_data.end_time + ' 23:59:59').getTime() / 1000 : '',
          }
        )
        if (response.status === 200 && result.code === 0) {
          this.statistic_data = result.data
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取活动数据统计失败',
            content: `${response.status} ${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取活动数据统计失败',
          content: `错误：${err}`,
        })
      }
    },
    // 获取数订单据统计
    async getOrderStatistic () {
      try {
        const { response, result } = await this.GetactivityOrderStatisticApi(
          {
            activity_id: this.activity_id,
            start_time: this.query_data.start_time ? new Date(this.query_data.start_time + ' 00:00:00').getTime() / 1000 : '',
            end_time: this.query_data.end_time ? new Date(this.query_data.end_time + ' 23:59:59').getTime() / 1000 : '',
            page: this.pagination_data.current_page,
            per_page: this.pagination_data.per_page,
          }
        )
        if (response.status === 200 && result.code === 0) {
          this.order_statistic_data = result.data
          this.pagination_data = result.meta
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取活动数据统计失败',
            content: `${response.status} ${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取活动数据统计失败',
          content: `错误：${err}`,
        })
      }
    },
  },
  mounted () {
    this.activity_id = this.$route.query.id
    this.query_data = JSON.parse(JSON.stringify(this.filter_data))
    this.getStatistic() // 获取数据统计
    this.getOrderStatistic() // 获取订单数据统计
  },
}
</script>

<style scoped lang="stylus">
@import '~@/stylus/mixins'
// @import '~@/stylus/modules/creation-modal'
.no-border
  border none !important
.head-content
  display flex
  justify-content space-between
.section-layout
  height calc(100% - 56px)
.content-layout-list
  min-height calc(100% - 346px)
  overflow-y auto
.margin
  margin 0 8px
  font-size 14px
.nav-back-btn
  position absolute
  top 18px
  left 16px
  width 32px
  height 32px
  border-radius 100%
  background #CED3DC center no-repeat url('~@/assets/back.svg')
  background-size 16px
  box-shadow 0 2px 6px 0 rgba(0, 0, 0, 0.08)
  cursor pointer
  z-index 2
.title-filter
  padding 25px 65px 10px
  background #e8e9eb
.time
  position absolute
  right 40px
  bottom 20px
  border-radius 3px
  border 1px solid #D9D9D9
  box-sizing border-box
.time .day, .time .month
  display inline-block
  width 78px
  height 28px
  line-height 28px
  text-align center
  font-size 14px
  border-radius 3px
  background #D9D9D9
  color #9A9B9A
  cursor pointer
.active
  color #121212 !important
  background #FFFFFF !important
.m-b-20
  margin-bottom 20px
.p-t-20
  padding-bottom 20px
.revenue
  padding-top 0px
  box-sizing border-box
.top-total
  overflow unset !important
  background #e8e9eb !important
  padding 10px 30px 0 !important
.income
  background #ffffff
  height 100px
  display flex
  justify-content flex-start
  align-items center
.statistics
  width 33%
  text-align left
  padding-left 30px
  border-left 1px solid #D9D9D9
  box-sizing border-box
  .title
    font-size 16px
    color #999999
    font-weight 500
  .price
    margin-top 10px
    font-size 30px
    color #404040
    font-weight 500
.list-height
  height 300px
.order-statistics
  background #ffffff
  margin-top 20px
  box-sizing border-box
.inspect-store
  max-height 300px
  overflow-y auto
.order-income, .order-income-content
  background #ffffff
  display flex
  height 40px
  line-height 40px
  justify-content flex-start
  align-items center
  border-bottom 1px solid #F1F1F1
  box-sizing border-box
.order-income-content
  border-bottom none
  height 40px
  line-height 40px
.order-income li, .order-income-content li
  width 33%
  font-size 14px
  color #999999
  font-weight 500
  padding-left 30px
  display inline-block
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
li.date
  width 450px !important
.order-income-content li
  color #353535
  font-weight 400
</style>



// WEBPACK FOOTER //
// src/components/content/ContentStatistic.vue